import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import Editor from "../../components/WriteProject/Editor/Editor";
import UseWritePost from "../../hooks/UseWritePost";
import { ToastChange } from "../../reducers/config";
import "./css/index.css";
type LocationType = {
  state: {
    status: "new" | "fix";
    data: any;
  };
};

/** 공지사항 작성 페이지 */
const WriteNotice = () => {
  const dispatch = useDispatch();
  const {
    state: { status, data },
  } = useLocation() as LocationType;
  const [title, setTitle] = useState<string>(
    status === "fix" ? data.ctts_tit : ""
  );
  const [WritePost] = UseWritePost(
    `공지사항 ${status === "fix" ? "수정" : "등록"} 완료`
  );
  /** 노티스 작성 함수 */
  const insertNotice = useCallback(
    (template: any) => {
      let WriteData =
        status === "new"
          ? {
              bbs_id: "3",
              ctts_tit: title,
              ctts_ctts: template,
              ctts_link: "link",
            }
          : {
              bbs_id: "3",
              ctts_tit: title,
              ctts_ctts: template,
              ctts_id: data.ctts_id,
            };
      if (title) {
        WritePost(WriteData, true);
      } else {
        dispatch(
          ToastChange({
            active: true,
            content: "제목을 입력해주세요",
          })
        );
      }
    },
    [title, dispatch, data, status, WritePost]
  );

  return (
    <main className="write-notice-page">
      <div className="wrapper">
        <div className="tag">제목</div>
        <input
          type="text"
          className="notice-title-input"
          placeholder="제목을 입력해주세요"
          value={title}
          onChange={(e) => {
            setTitle(e.target.value);
          }}
        />
        <div className="tag">내용</div>
        <Editor
          type="notice"
          Insert={insertNotice}
          fixData={data ? data.ctts_ctts : undefined}
          status={status}
          Save={undefined}
        />
      </div>
    </main>
  );
};

export default WriteNotice;
